import { Box, makeStyles } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const useStyles = makeStyles((theme) => ({
  containerText: {
    margin: theme.spacing(4, 0),
  },
}));
function SkeletonContainerText() {
  const classes = useStyles();
  return (
    <Box>
      <Skeleton variant="rect" width="95%" height={50} />
      <Box className={classes.containerText}>
        <Skeleton variant="rect" width="95%" height={600} />
      </Box>
    </Box>
  );
}

export default SkeletonContainerText;
